import React from 'react';
import { CameraIcon, PhotographIcon } from '@heroicons/react/solid';
import Modal from './Modal';

const UpdateProfileModal = ({ modal, onClick, onOutsideClick }) => (
  <Modal
    modal={modal}
    customContentClassName="max-w-screen-md mx-auto absolute bottom-0 left-0 right-0 bg-white rounded-t-[20px] transition-all overflow-hidden z-50 p-5 pb-10"
    customContent={
      <div className="flex flex-col gap-6">
        <p className="text-center text-lg font-bold font-inter text-gray-800">
          Select Photo Option
        </p>
        <div className="flex flex-col gap-4">
          <div
            className="flex items-center gap-3 p-3 active:bg-gray-100 rounded-lg cursor-pointer"
            onClick={() => onClick('camera')}>
            <div className="p-2 bg-blue-100 rounded-full">
              <CameraIcon className="w-6 h-6 text-[#5046E4]" />
            </div>
            <p className="font-inter text-base font-medium text-gray-700">Take Photo</p>
          </div>
          <div className="h-[1px] bg-gray-100 w-full" />
          <div
            className="flex items-center gap-3 p-3 active:bg-gray-100 rounded-lg cursor-pointer"
            onClick={() => onClick('gallery')}>
            <div className="p-2 bg-green-100 rounded-full">
              <PhotographIcon className="w-6 h-6 text-green-600" />
            </div>
            <p className="font-inter text-base font-medium text-gray-700">Choose from Gallery</p>
          </div>
        </div>
        <button
          type="button"
          className="mt-2 py-3 w-full text-center text-red-500 font-semibold border border-red-100 rounded-lg bg-red-50"
          onClick={onOutsideClick}>
          Cancel
        </button>
      </div>
    }
    onOutsideClick={onOutsideClick}
  />
);

export default UpdateProfileModal;
